import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { dateSorter } from '../../utils';
import { isBeforeToday } from '../../utils';
import { Link } from 'react-router-dom';
import { apiClient } from '../../api_actions';
import { useState, useEffect, useRef } from 'react';

const handleCancelEmail = async (record) => {
  await apiClient.post("update/cancel_email",record)
};

export default function EmailTrackingPage() {
  const [reloadTimestamp, setReloadTimestamp] = useState(0)
  const columns = [
    {
      title: 'Created At',
      dataIndex: 'unix_timestamp',
      key: 'unix_timestamp',
      render: (value) => {
        const date = new Date(value);
        if (isNaN(date.getTime()) || date.getTime() === -1000) return '';
        return date.toLocaleString(); // or format however you prefer
      },
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'Status',
      dataIndex: ['status', 'name'],
      key: 'status_name',
    }
  ];

  const formFields = [
    
    {
      name: 'unix_timestamp',
      label: 'Ending Date',
      type: 'date',  // This makes it a date picker
      placeholder: 'Select ending date',
      disabled: true,
    },
    {
        mode: "multiple",
        allowClear: true,
        name: 'user_ids',
        label: 'Users',
        type: 'select',
        optionsEndpoint: '/read/users',
        optionsLabel: ['email'], // Multiple fields!
        labelSeparator: ' - ',  // Optional, defaults to ' - '
        optionsValue: 'user_id',
        disabled: true
    },
        {
        name: 'subject',
        label: 'Subject',
        type: 'textarea',
        placeholder: 'subject',
        disabled: true
    },
    {
        name: 'raw_body',
        label: 'Body',
        type: 'textarea',
        placeholder: 'subject',
        disabled: true
    },
    {
        name: ['status','id'],
        label: 'Status',
        type: 'select',
        optionsEndpoint: '/read/email_statuses',
        optionsLabel: ['name'], // Multiple fields!
        optionsValue: 'id',
        searchable: true,
        disabled : true,
        rules: [{ required: true }],
    },
    {
      name: 'cancel',
      label: 'Cancel Email',
      type: 'button',
      buttonType: 'default',
      danger: true,
      //disabled: !isSuperAdmin,
      onClick: (record) => {
        handleCancelEmail(record)
        //setReloadTimestamp(Date.now())
      }
    },
  ];


  return (
    <div className='container-wrapper'>
      <ModalEditTable
        readEndpoint="read/emails"
        //editEndpoint="update/emails"
        //deleteEndpoint="delete/emails"
        columns={columns}
        formFields={formFields}
        canCreate={false}
        //canEdit = {true}
        canView = {true}
        canDelete={false}
        title="Emails"
        reloadTimestamp={reloadTimestamp}
      />
    </div>
  );
}